import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { APIURL } from "../../../Config";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import Pagination from "../../Pagination/Pagination";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { DownloadTableExcel } from "react-export-table-to-excel";
import * as Yup from "yup";
import moment from "moment";

function EmployerCreditAppraisal() {
  const email = localStorage.getItem("emailId");
  const token = localStorage.getItem("token");

  const [isLoader, setIsLoader] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [activeTab, setActiveTab] = useState("profile");
  const [empCredit, setEmpCredit] = useState([]);
  const [showPrePage, setShowPrePage] = useState(100);
  const tableEmployerCreditAppraisal = useRef(null);
  const [selectedEmployer, setSelectedEmployer] = useState(null);
  const [pagination, setPagination] = useState({
    start: 0,
    end: showPrePage,
  });
  const [showModal, setShowModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState("APPROVED");

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const calculateProgress = (values) => {
    let filledFields = 0;
    const fields = Object.keys(values);
    fields.forEach((field) => {
      if (values[field]) {
        filledFields++;
      }
    });
    const progress = (filledFields / fields.length) * 100;
    return progress > 100 ? 100 : progress;
  };

  useEffect(() => {
    getEmployercreditappraiser();
  }, []);

  const getEmployercreditappraiser = () => {
    setIsLoader(true);
    axios
      .get(`${APIURL}/corporate/employercreditappraiser`, {
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        setEmpCredit(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
        toast.error("Failed to fetch employer credit data");
      });
  };

  const validationSchema = Yup.object().shape({
    fundemployees: Yup.string().required("Please select an option"),
    address: Yup.string().required("required"),
    companyname: Yup.string().required("required"),
    empname: Yup.string().required("required"),
    numberofemployees: Yup.string().required("required"),
    mobile: Yup.string().required("required"),
    corpadminmail: Yup.string().required("required"),
    remarks: Yup.string().required("required"),
    commercialfees: Yup.string().required("required"),
    // loantypestatus: Yup.string().required("Please select an option"),
    setupfees: Yup.string().required("required"),
    companytype: Yup.string().required("Please select an option"),
    status: Yup.string().required("Please select an option"),
  });

  const handleRejected = () => {
    setIsLoader(true);
    axios
      .post(
        `${APIURL}/corporate/employercreditappraiserUpdate`,
        { ...remark, status: "REJECTED", ownerEmail: email },
        {
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        getEmployercreditappraiser();
        toast.success("Updated successfully");
        setShowModal(false);
        setShowSearch(false);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
        toast.error("Failed to update employer credit");
      });
  };

  const handleApproved = (values) => {
    setIsLoader(true);
    console.log("values.loantypestatus::: ", values.loantypestatus);

    if (
      values.loantypestatus != 2 &&
      (values.commercialfees === undefined || values.commercialfees === "") &&
      (values.salaryPercentage === undefined || values.salaryPercentage === "")
    ) {
      toast.error("Convenience fee & % Field are required");
      setIsLoader(false);
    } else {
      axios
        .post(
          `${APIURL}/corporate/employercreditappraiserUpdate`,
          { ...values, status: "APPROVED", ownerEmail: email },
          {
            headers: {
              Authentication: token,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setIsLoader(false);
          getEmployercreditappraiser();
          toast.success("Approved successfully");
          setShowModal(false);
          setShowSearch(false);
        })
        .catch((error) => {
          setIsLoader(false);
          console.log(error);
          toast.error("Failed to approve employer credit");
        });
    }
  };

  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item"
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              Employer Credit Appraisal
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {showSearch ? (
              <div>
                <ul className="nav nav-tabs d-flex justify-content-between align-items-center">
                  <div className="d-flex">
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link ${
                          activeTab === "profile" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("profile")}
                      >
                        Credit Appraisal {selectedEmployer?.employer_name}
                      </button>
                    </li>
                  </div>
                  <li className="nav-item ml-auto" role="presentation">
                    <button
                      className="btn btn-secondary"
                      style={{ width: "100px" }}
                      onClick={() => setShowSearch(false)}
                    >
                      Back
                    </button>
                  </li>
                </ul>
                <div className="tab-content mt-3">
                  {activeTab === "profile" && (
                    <div className="tab-pane fade show active card">
                      <div className="container p-4 scrollable-container">
                        <div className="row">
                          <div className="col-md-12">
                            <Formik
                              initialValues={{
                                corpadminmail: remark?.email || "",
                                companyname: remark?.employer_name || "",
                                empname: remark?.employee_name || "",
                                mobile: remark?.mobile || "",
                                numberofemployees: remark?.noofemployees || "",
                                address: remark?.address || "",
                                hrapp: remark?.hrapp || "no",
                                fundemployees: remark?.fundemployees || "",
                                model: remark?.model || "Assured",
                                companytype: remark?.companytype || "",
                                employercode: remark?.employercode || "",
                                commercialfees: remark?.commercialfees || "",
                                salaryPercentage:
                                  remark?.salaryPercentage || "",
                                salarypercentageStatus:
                                  remark?.salaryPercentage === "" ||
                                  remark?.salaryPercentage === 0
                                    ? 0
                                    : 1,
                                setupfees: remark?.setupfees || "100",
                                status: status,
                                websiteaddress: remark?.websiteAddress || "",
                                remarks: remark?.remarks || "",
                                loantypestatus:
                                  remark?.loantypestatus?.toString() || "3",
                              }}
                              validationSchema={validationSchema}
                              onSubmit={handleApproved}
                            >
                              {({
                                touched,
                                errors,
                                setFieldValue,
                                values,
                                handleSubmit,
                                handleChange,
                              }) => (
                                <Form onSubmit={handleSubmit}>
                                  <div>
                                    <div className="mb-2">
                                      <label>Work Email*</label>
                                      <Field
                                        type="email"
                                        name="corpadminmail"
                                        placeholder="Enter company email"
                                        className={`form-control ${
                                          touched.corpadminmail &&
                                          errors.corpadminmail
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="corpadminmail"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <label>Emp Name*</label>
                                      <Field
                                        type="text"
                                        name="empname"
                                        placeholder="Enter name"
                                        className={`form-control ${
                                          touched.empname && errors.empname
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="empname"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <label>Employer Name*</label>
                                      <Field
                                        type="text"
                                        name="companyname"
                                        placeholder="Enter company name"
                                        className={`form-control ${
                                          touched.companyname &&
                                          errors.companyname
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="companyname"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <label>Mobile No*</label>
                                      <Field
                                        type="number"
                                        name="mobile"
                                        placeholder="Enter mobile no"
                                        className={`form-control ${
                                          touched.mobile && errors.mobile
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="mobile"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <label>No. of employees*</label>
                                      <Field
                                        type="number"
                                        name="numberofemployees"
                                        placeholder="Enter number of employees"
                                        className={`form-control ${
                                          touched.numberofemployees &&
                                          errors.numberofemployees
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="numberofemployees"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="mt-2">
                                      <label>Address*</label>
                                      <Field
                                        type="text"
                                        name="address"
                                        placeholder="Enter address"
                                        className={`form-control ${
                                          touched.address && errors.address
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="address"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    {/* <div className="form-group mt-2">
                                      <label>
                                        I would like to use my own funds to fund
                                        my employees
                                      </label>
                                      <div className="d-flex">
                                        <div className="form-check ml-2">
                                          <Field
                                            type="radio"
                                            name="fundemployees"
                                            value="no"
                                            className={`form-check-input border-3 ${
                                              touched.fundemployees &&
                                              errors.fundemployees
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                          />
                                          <label className="form-check-label">
                                            No
                                          </label>
                                        </div>
                                        <div className="form-check ml-4">
                                          <Field
                                            type="radio"
                                            name="fundemployees"
                                            value="yes"
                                            className={`form-check-input border-3 ${
                                              touched.fundemployees &&
                                              errors.fundemployees
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                          />
                                          <label className="form-check-label">
                                            Yes
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        component="div"
                                        name="fundemployees"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="form-group mt-2">
                                      <label>Loan Type*</label>
                                      <div className="d-flex">
                                        <div className="form-check ml-2">
                                          <Field
                                            type="radio"
                                            id="creditLine"
                                            name="loantypestatus"
                                            value="1"
                                            className={`form-check-input border-3 ${
                                              touched.loantypestatus &&
                                              errors.loantypestatus
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="creditLine"
                                          >
                                            Credit Line
                                          </label>
                                        </div>
                                        <div className="form-check ml-4">
                                          <Field
                                            type="radio"
                                            id="personalLoan"
                                            name="loantypestatus"
                                            value="2"
                                            className={`form-check-input border-3 ${
                                              touched.loantypestatus &&
                                              errors.loantypestatus
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="personalLoan"
                                          >
                                            Personal Loan
                                          </label>
                                        </div>
                                        <div className="form-check ml-4">
                                          <Field
                                            type="radio"
                                            id="bothLoans"
                                            name="loantypestatus"
                                            value="3"
                                            className={`form-check-input border-3 ${
                                              touched.loantypestatus &&
                                              errors.loantypestatus
                                                ? "is-invalid"
                                                : ""
                                            }`}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="bothLoans"
                                          >
                                            Both
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        component="div"
                                        name="loantypestatus"
                                        className="invalid-feedback"
                                      />
                                    </div> */}

                                    {values.loantypestatus &&
                                      values.loantypestatus !== "2" && (
                                        <div className="row">
                                          <div className="form-group col-12 mt-3">
                                            <label>Onetime Setup Fee*</label>
                                            <Field
                                              type="number"
                                              name="setupfees"
                                              placeholder="Enter %"
                                              className={`form-control ${
                                                touched.setupfees &&
                                                errors.setupfees
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                            />
                                            <ErrorMessage
                                              component="div"
                                              name="setupfees"
                                              className="invalid-feedback"
                                            />
                                          </div>
                                          <div className="form-group col-12">
                                            <label>Convenience fee*</label>
                                            <Field
                                              type="number"
                                              name="commercialfees"
                                              placeholder="Enter convenience fees"
                                              className={`form-control ${
                                                touched.commercialfees &&
                                                errors.commercialfees
                                                  ? "is-invalid"
                                                  : ""
                                              }`}
                                            />
                                            <ErrorMessage
                                              component="div"
                                              name="commercialfees"
                                              className="invalid-feedback"
                                            />
                                          </div>
                                        </div>
                                      )}

                                    <div className="mt-2">
                                      <label>Remark*</label>
                                      <Field
                                        as="textarea"
                                        name="remarks"
                                        placeholder="Enter remark"
                                        className={`form-control ${
                                          touched.remarks && errors.remarks
                                            ? "is-invalid"
                                            : ""
                                        }`}
                                      />
                                      <ErrorMessage
                                        component="div"
                                        name="remarks"
                                        className="invalid-feedback"
                                      />
                                    </div>

                                    <div className="d-flex justify-content-end mt-3">
                                      <button
                                        className="btn btn-success border px-3 py-2"
                                        type="submit"
                                        style={{
                                          backgroundColor: "#66a725",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {isLoader ? (
                                          <div
                                            className="spinner-border text-success"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          "APPROVED"
                                        )}
                                      </button>

                                      <button
                                        className="btn btn-danger border px-3 py-2 ml-2"
                                        type="button"
                                        onClick={handleRejected}
                                        style={{ fontSize: "14px" }}
                                      >
                                        {isLoader ? (
                                          <div
                                            className="spinner-border text-danger"
                                            role="status"
                                          >
                                            <span className="sr-only">
                                              Loading...
                                            </span>
                                          </div>
                                        ) : (
                                          "REJECTED"
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </Form>
                              )}
                            </Formik>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="pt-3">
                <div className="card">
                  <DownloadTableExcel
                    filename="EmployerCreditAppraisal"
                    sheet="users"
                    currentTableRef={tableEmployerCreditAppraisal.current}
                  >
                    <button
                      className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                      style={{
                        width: "120px",
                        backgroundColor: "#66a725",
                      }}
                    >
                      Download
                    </button>
                  </DownloadTableExcel>

                  <div className="p-3 pt-4">
                    {isLoader ? (
                      <div className="d-flex justify-content-center">
                        <div
                          className="spinner-border text-success"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th style={{ textAlign: "center" }}>Sr. No</th>
                              <th style={{ textAlign: "center" }}>
                                Entry Date
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Employer name
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Contact name
                              </th>
                              <th style={{ textAlign: "center" }}>Mobile</th>
                              <th style={{ textAlign: "center" }}>Appraise</th>
                            </tr>
                          </thead>
                          <tbody>
                            {empCredit?.map((item, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  {new Date(item?.date).toLocaleString("en-GB")}
                                </td>
                                <td>{item.employer_name}</td>
                                <td>{item.employee_name}</td>
                                <td>{item.mobile}</td>
                                <td>
                                  <button
                                    className="btn btn-warning"
                                    onClick={() => {
                                      setRemark(item);
                                      setShowSearch(true);
                                      setSelectedEmployer(item);
                                    }}
                                  >
                                    Appraise
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {empCredit && empCredit.length !== 0 && (
                      <Pagination
                        showPrePage={showPrePage}
                        onPaginationChange={onPaginationChange}
                        total={empCredit.length}
                      />
                    )}

                    {/* Hidden table for export */}
                    <table
                      className="table table-striped mt-3"
                      style={{ display: "none" }}
                      ref={tableEmployerCreditAppraisal}
                    >
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>Entry Date</th>
                          <th style={{ textAlign: "center" }}>Employer name</th>
                          <th style={{ textAlign: "center" }}>Contact name</th>
                          <th style={{ textAlign: "center" }}>Date</th>
                          <th style={{ textAlign: "center" }}>Mobile</th>
                          <th style={{ textAlign: "center" }}>Code</th>
                          <th style={{ textAlign: "center" }}>Company</th>
                          <th style={{ textAlign: "center" }}>Appraise</th>
                        </tr>
                      </thead>
                      <tbody>
                        {empCredit?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>
                              {new Date(item?.date).toLocaleString("en-GB")}
                            </td>
                            <td>{item.employer_name}</td>
                            <td>{item.employee_name}</td>
                            <td>{item.date}</td>
                            <td>{item.mobile}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.companytype}
                            </td>
                            <td>{item.company}</td>
                            <td>Appraise</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployerCreditAppraisal;
